// ink-component
import React from 'react';
import { ThemeProvider } from 'styled-components';
import { FeedbackVariants } from '../../../_common/Types/GlobalTypes';

import { StyledRibbon } from './styles';

export interface NewTableRibbonProps extends React.HTMLAttributes<HTMLDivElement> {
  /** Text contents */
  text: string;
  /** Semantic variants, based on intent */
  variant?: Extract<
    FeedbackVariants,
    | 'feedback-positive'
    | 'feedback-negative'
    | 'feedback-notice'
    | 'feedback-neutral'
    | 'feedback-pending'
    | 'feedback-informational'
    | 'feedback-staff'
  >;
  /** Ribbon color */
  color?: 'green' | 'red' | 'blue' | 'orange' | 'yellow' | 'gray' | 'pink';
  /** @ignore */
  hover?: 'row' | 'cell' | 'self';
}

/**
 * @group NewTable
 * @purpose Display row temporary information on hover
 * @categories table
 * @HTMLType HTMLDivElement
 */

function NewTableRibbon(props: NewTableRibbonProps) {
  const { style, className, children, variant, color, hover = 'row', ...otherProps } = props;

  return (
    <ThemeProvider
      theme={currentTheme => ({
        ...currentTheme,
        ribbonVariant: variant,
        ribbonColor: color,
        ribbonHover: hover,
      })}
    >
      <StyledRibbon {...otherProps} />
    </ThemeProvider>
  );
}

NewTableRibbon.defaultProps = {
  color: 'blue',
  hover: 'row',
};

NewTableRibbon.displayName = 'NewTable.Ribbon';

export default NewTableRibbon;
